import {ErrorMessage} from 'angular-error-repository';

export const minLengthError: ErrorMessage<{
    actualLength: number;
    charactersShort: number;
    requiredLength: number;
}> = error => {
    const {actualLength, requiredLength} = error.error;
    error.error.charactersShort = requiredLength - actualLength;
    return `Min length`;
};
